import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_RENTERS_VEHICLEINQUIRY_LIST, 
  TOAST, 
  FETCH_RENTERS_VEHICLEINQUIRY_INIT,
  FETCH_RENTERS_VEHICLEINQUIRY_DETAIL,
  EXPORT_RENTERS_VEHICLEINQUIRY,
  EXPORTPDF_RENTERS_VEHICLEINQUIRY,
  EXPORTCSV_RENTERS_VEHICLEINQUIRY,
  CREATE_RENTERS_VEHICLEINQUIRY,
  EDIT_RENTERS_VEHICLEINQUIRY,
  INIT_CREATE_RENTERS_VEHICLEINQUIRY_SCREEN,
  RENTERS_VEHICLEINQUIRYDD,
  RENTERS_VEHICLEINQUIRYDELETE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY
} from "../../../types/Renters/VehicleInquiry.type";



  const formFieldValueMap = {
    dailyBudget:"",
description:"",
dropOffDate:"",
emailId:"",
firstName:"",
lastName:"",
location:"",
phoneNumber:"",
pickupDate:"",
vehicleName:"",
    id:null,
    modBy:"",
    modTime:"",
    userId:""
  };
  
  const INITIAL_STATE = {
    RentersVehicleInquiryListview: [],
    RentersVehicleInquiryDD:[],
    isRentersVehicleInquiryDDSuccess: false,
    isRentersVehicleInquiryDDError: false,
    isLoading: false,
    error: null,
    formFieldValueMap,
    isRentersVehicleInquiryCreateSuccess: false,
    isRentersVehicleInquiryCreateError: false,
    isRentersVehicleInquiryDetailSuccess: false,
    isRentersVehicleInquiryDetailError: false,
    isRentersVehicleInquiryEditSuccess: false,
    isRentersVehicleInquiryEditError: false,
    isRentersVehicleInquiryExportSuccess: false,
    isRentersVehicleInquiryExportError: false,
    isUploadImageSuccess: false,
    isUploadImageError: false,
    imageUploadResponse:null,
    isRentersVehicleInquiryDeleteSuccess: false,
    isRentersVehicleInquiryDeleteError: false,
  };
  
  const tranformToGridView = (data) => {
    const rows = data.map((item) => {
      const {
id,
name,
emailId,
phoneNumber,
location,
dailyBudget,
vehicleName,
hasInsurance,
mobileDesktop,
inquiryDate,
status,
createdBy,
createdTime,
modifiedBy,
modifiedTime,
      } = item;
  
      const transformedValues = {
        id,
name,
emailId,
phoneNumber,
location,
dailyBudget,
vehicleName,
hasInsurance,
mobileDesktop,
inquiryDate,
status,
createdBy,
createdTime,
modifiedBy,
modifiedTime,
      };
      const decoratedValues = {};
      Object.keys(transformedValues).forEach((key) => {
        decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
      });
      return decoratedValues;
    });
  
    const columns = [
      {
        colLabel: "ID",
        dataKey: "id",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Name",
        dataKey: "name",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Email Id",
        dataKey: "emailId",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      
      {
        colLabel: "Phone Number",
        dataKey: "phoneNumber",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Location",
        dataKey: "location",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Daily Budget",
        dataKey: "dailyBudget",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },


      {
        colLabel: "Vehicle Details",
        dataKey: "vehicleName",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Has Insurance",
        dataKey: "hasInsurance",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Mobile Desktop",
        dataKey: "mobileDesktop",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Inquiry Date",
        dataKey: "inquiryDate",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
     
      {
        colLabel: "Crt By",
        dataKey: "createdBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Crt Time",
        dataKey: "createdTime",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Mod By",
        dataKey: "modifiedBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Edit Time",
        dataKey: "modifiedTime",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Status",
        dataKey: "status",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      }
    ];
  
    return {
      datas: { columns, rows },
    };
  };

  export const RentersVehicleInquiryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_RENTERS_VEHICLEINQUIRY_INIT:
        return { ...INITIAL_STATE, isLoadingPage: true };
      case FETCH_RENTERS_VEHICLEINQUIRY_DETAIL.START:
      case EXPORT_RENTERS_VEHICLEINQUIRY.START:
        case EXPORTPDF_RENTERS_VEHICLEINQUIRY.START:
          case EXPORTCSV_RENTERS_VEHICLEINQUIRY.START:
        case UPLOAD_IMAGE.START:
      case FETCH_RENTERS_VEHICLEINQUIRY_LIST.START:
      case CREATE_RENTERS_VEHICLEINQUIRY.START:
        case RENTERS_VEHICLEINQUIRYDELETE.START:
        case EDIT_RENTERS_VEHICLEINQUIRY.START:
          case RENTERS_VEHICLEINQUIRYDD.START:
        return { ...state, isLoading: true };
  
      case FETCH_RENTERS_VEHICLEINQUIRY_LIST.SUCCESS: {
        const { page, data } = action.payload;
       
        let resetState = {
          RentersVehicleInquiryListview: [],
          paginationInfo:null,
          error: null,
          isLoading: false,
          isLoadingPage: false,
          isPageLevelError: false,
          isRentersVehicleInquiryCreateSuccess: false,
          isRentersVehicleInquiryCreateError: false,
        };
        if (!data) {
          return resetState;
        }
        const { number, size, totalElements, totalPages } = page;
        const { datas } = tranformToGridView(data);
        return {
          ...resetState,
          RentersVehicleInquiryListview: datas,
          paginationInfo: {
            pageSize: size,
            totalRecords: totalElements,
            totalPages: totalPages,
            pageNumber: number,
          },
        };
      }
      case FETCH_RENTERS_VEHICLEINQUIRY_LIST.ERROR: {
        const { error } = action.payload;
  
        return {
          ...state,
          RentersVehicleInquiryListview: [],
          isLoading: false,
          isLoadingPage: false,
          error,
          isPageLevelError: true,
          isRentersVehicleInquiryDeletionSuccess: false,
          isRentersVehicleInquiryDeletionError: false,
          shouldOpenDeleteConfirmationPopup: false,
        };
      }

    case FETCH_RENTERS_VEHICLEINQUIRY_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
              temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isRentersVehicleInquiryDetailSuccess: true,
      };
    }
    case FETCH_RENTERS_VEHICLEINQUIRY_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isRentersVehicleInquiryDetailSuccess: false,
        isRentersVehicleInquiryDetailError: true,
      };
    }

    //DD
    case RENTERS_VEHICLEINQUIRYDD.SUCCESS: {
      const temp = action.payload;
 
      return {
        ...state,
        isLoading: false,
        RentersVehicleInquiryDD:temp,
        isRentersVehicleInquiryDDSuccess: true,
        isRentersVehicleInquiryDDError: false,
      };
    }
    case RENTERS_VEHICLEINQUIRYDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isRentersVehicleInquiryDDSuccess: false,
        isRentersVehicleInquiryDDError: true,
      };
    }
    //END DD
//DELETE

case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY: {
  const shouldOpenDeleteConfirmationPopup = action.payload;
  return {
    ...state,
    shouldOpenDeleteConfirmationPopup,
    isRentersVehicleInquiryDeleteSuccess: false,
    isRentersVehicleInquiryDeleteError: false,
  };
}
case RENTERS_VEHICLEINQUIRYDELETE.SUCCESS: {
  const temp = action.payload;

  return {
    ...state,
    isLoading: false,
    isRentersVehicleInquiryDeleteSuccess: true,
    isRentersVehicleInquiryDeleteError: false,
    shouldOpenDeleteConfirmationPopup: false,
  };
}
case RENTERS_VEHICLEINQUIRYDELETE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    error,
    isRentersVehicleInquiryDeleteSuccess: false,
    isRentersVehicleInquiryDeleteError: true,
    shouldOpenDeleteConfirmationPopup: false,
  };
}
//END DD   
    
// UPLOAD_IMAGE Start
case UPLOAD_IMAGE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isUploadImageSuccess: false,
    isUploadImageError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case UPLOAD_IMAGE.SUCCESS: {
  const  {data}  = action.payload;
   return {
    ...state,
    imageUploadResponse:data,
    isUploadImageSuccess: true,
    isUploadImageError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// UPLOAD_IMAGE End

// Export Start
case EXPORT_RENTERS_VEHICLEINQUIRY.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isRentersVehicleInquiryExportSuccess: false,
    isRentersVehicleInquiryExportError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case EXPORT_RENTERS_VEHICLEINQUIRY.SUCCESS: {
  const  data  = action.payload;
  arrayBufferDownloadExcel(data,"vehicle-inquiry.xls");
   return {
    ...state,
    isRentersVehicleInquiryExportSuccess: true,
    isRentersVehicleInquiryExportError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// Export End

// Export Start PDF
case EXPORTPDF_RENTERS_VEHICLEINQUIRY.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isRentersVehicleInquiryExportPDFSuccess: false,
    isRentersVehicleInquiryExportPDFError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case EXPORTPDF_RENTERS_VEHICLEINQUIRY.SUCCESS: {
  const  data  = action.payload;
  arrayBufferDownloadExcel(data,"vehicle-inquiry.pdf");
   return {
    ...state,
    isRentersVehicleInquiryExportPDFSuccess: true,
    isRentersVehicleInquiryExportPDFError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// Export End

// Export Start CSV
case EXPORTCSV_RENTERS_VEHICLEINQUIRY.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isRentersVehicleInquiryExportCSVSuccess: false,
    isRentersVehicleInquiryExportCSVError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case EXPORTCSV_RENTERS_VEHICLEINQUIRY.SUCCESS: {
  const  data  = action.payload;
  arrayBufferDownloadExcel(data,"vehicle-inquiry.csv");
   return {
    ...state,
    isRentersVehicleInquiryExportCSVSuccess: true,
    isRentersVehicleInquiryExportCSVError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// Export End
// EDIT
case EDIT_RENTERS_VEHICLEINQUIRY.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isRentersVehicleInquiryEditSuccess: false,
    isRentersVehicleInquiryEditError: true,
  };
}

case EDIT_RENTERS_VEHICLEINQUIRY.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isRentersVehicleInquiryEditSuccess: true,
    isRentersVehicleInquiryEditError: false,
  };
}

// EDIT END

// Create
case INIT_CREATE_RENTERS_VEHICLEINQUIRY_SCREEN: {
  return { ...INITIAL_STATE };
}

case CREATE_RENTERS_VEHICLEINQUIRY.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isRentersVehicleInquiryCreateSuccess: false,
    isRentersVehicleInquiryCreateError: true,
  };
}
case CREATE_RENTERS_VEHICLEINQUIRY.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isRentersVehicleInquiryCreateSuccess: true,
    isRentersVehicleInquiryCreateError: false,
  };
}

//End
  

      case TOAST.RESET: {
        return {
          ...state,
          isRentersVehicleInquiryCreateSuccess: false,
          isRentersVehicleInquiryCreateError: false,
          isRentersVehicleInquiryEditError: false,
          isRentersVehicleInquiryEditSuccess: false,
          isRentersVehicleInquiryDetailError: false
        };
      }
      default:
        return state;
    }
  };
  